export default __webpack_public_path__ + "static/media/archer.1b3fd5a0.png";